import { NavLink } from 'react-router-dom';
import { ReportsMap } from './Constants';
import './Reporting.css';
import { observer, inject } from 'mobx-react';

const ReportsMenu = inject('RootStore')(observer(({ RootStore }) => {
    if(RootStore.userStore.isUserManager && (!RootStore.userStore.isUserSoxCompliance && !RootStore.userStore.isUserAdmin && !RootStore.userStore.isUserCiso)){
        return (
            <>
                <div className="col-sm-2">
                    <div className="dropdown">
                        <div className="dropdown-menu show">
                            <span className="selectReport">
                            Reports
                            </span>
                            <NavLinkWrapper ReportName={"All Employee Accounts"} />
                        </div>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <div className="col-sm-2">
                <div className="dropdown">
                    {/* <h3>Reporting Service</h3> */}
                    {/* <button className="btn btn-dark dropdown-toggle form-control" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Select Report
                    </button> */}
                    <div className="dropdown-menu show">
                        <span className="selectReport">
                        Reports
                        </span>
                        <NavLinkWrapper ReportName={"Inactive Employee Accounts"} />
                        <NavLinkWrapper ReportName={"All Employee Accounts"} />
                        {/* <NavLinkWrapper ReportName={"Intersection"}/> */}
                        <NavLinkWrapper ReportName={"Employees Without Roles"} />
                        {/* <NavLinkWrapper ReportName={"Permission Group Changes"} /> */}
                        <NavLinkWrapper ReportName={"Not Recognized Users"} />
                        {/* <NavLinkWrapper ReportName={"GCP Report"} /> */}
                        <NavLinkWrapper ReportName={"Permission Groups Without Description"} />
                        <NavLinkWrapper ReportName={"Password Never Expires Report"} />
                        {/* <NavLinkWrapper ReportName={"QAR Findings"} /> */}
                    </div>
                </div>
            </div>
        </>
    );
}));

const NavLinkWrapper = (props) => {
    return (
        <NavLink className='nav-link nav-item' data-toggle="pill" to={ReportsMap[props.ReportName]} role='tab' aria-selected="false">{props.ReportName}</NavLink>
    )
}

export default ReportsMenu;
